/**
 * Sign-in navigation helpers (APP-001 §7, §8).
 *
 * Centralizes redirects to the Clerk-backed sign-in route so the redirect is
 * always validated and the current path preserved as a return intent.
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClerk } from '@clerk/clerk-react';
import { parseReturnIntent } from './returnPath';

export function useSignInHelpers() {
  const navigate = useNavigate();

  const navigateToSignIn = useCallback(() => {
    navigate('/sign-in');
  }, [navigate]);

  const navigateToDashboard = useCallback(() => {
    navigate('/dashboard');
  }, [navigate]);

  return { navigateToSignIn, navigateToDashboard };
}

/**
 * Sign-out hook. Clears the Clerk session and returns to /sign-in. The current
 * path is dropped intentionally (no preserved return after sign-out).
 */
export function useSignOutAndRedirect() {
  const navigate = useNavigate();
  const clerk = useClerk();
  return useCallback(async () => {
    try {
      await clerk.signOut({ redirectUrl: '/sign-in' });
    } finally {
      navigate('/sign-in', { replace: true });
    }
  }, [clerk, navigate]);
}

export { parseReturnIntent };
